/**
 * Download/Export Component
 *
 * In order to trigger downloads in Javascript we need to trigger a click on an <a download /> tag
 * This component checks for the existance of a url prop
 * 		If it's changed, after the render, it will trigger a click event on the component
 * 		Once that happens the UI should download the file
 * 		We then should notify the parent that the download happened
 * 			It's the parent's responsibility to clear out the url prop
 *
 * TODO: Move into Rhombus
 */
import React from "react";
import PropTypes from "prop-types";

export default class Downloader extends React.Component {

	static defaultProps = {
		url:null,
		onDownload:null,
		downloadName:null,
	};

	static propTypes = {
		url: PropTypes.string,
		onDownload: PropTypes.func.isRequired,
	};

	componentDidMount(){
		if(this.props.url){
			this.downloader.click();
			this.props.onDownload();
		}
	}

	componentDidUpdate(prevProps){
		if(this.props.url && this.props.url !== prevProps.url){
			this.downloader.click();
			this.props.onDownload();
		}
	}

	render(){
		let { downloadName, url } = this.props
			, aProps = {
				href:url,
				ref:down => this.downloader = down,
				className:"is-a-download",
				target:"_BLANK",
				rel:"noreferrer noopener",
			}
			;

		if(downloadName){
			return <a {...aProps} download={downloadName} />;
		}

		return <a {...aProps} download  />;
 	}

}
